<!-- Backdrop -->
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50" (click)="close()">
  <!-- Dialog -->
  <div class="bg-white dark:bg-[#1e2452] rounded-xl shadow-xl w-full max-w-md mx-4 p-6" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="flex items-center justify-between mb-6">
      <div class="flex items-center gap-3">
        <img src="assets/images/livespace.png" alt="Livespace" class="w-10 h-10 rounded-lg object-contain"/>
        <div>
          <h2 class="text-lg font-semibold text-gray-900 dark:text-white">Connect Livespace</h2>
          <p class="text-sm text-gray-500 dark:text-gray-400">Enter your API credentials</p>
        </div>
      </div>
      <button (click)="close()" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <!-- Instructions -->
    <div class="bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg p-3 mb-5">
      <p class="text-sm text-blue-800 dark:text-blue-300">
        Find your API Key and Secret in Livespace under
        <strong>Account Settings &rarr; API &rarr; Users</strong>.
      </p>
      <a *ngIf="form.get('subdomain')?.value"
        [href]="'https://' + form.get('subdomain')?.value + '.livespace.io/Settings/api'"
        target="_blank" rel="noopener noreferrer"
        class="inline-flex items-center gap-1 mt-2 text-xs font-medium text-blue-600 dark:text-blue-400 hover:underline">
        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/>
        </svg>
        Open API settings in Livespace
      </a>
    </div>

    <!-- Form -->
    <form [formGroup]="form" (ngSubmit)="connect()" class="space-y-4">
      <!-- Subdomain -->
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Subdomain</label>
        <div class="flex items-center">
          <span class="text-sm text-gray-400 mr-1">https://</span>
          <input formControlName="subdomain" type="text" placeholder="yourcompany"
            class="flex-1 px-3 py-2 border border-gray-200 dark:border-gray-600 dark:bg-[#252c5f] dark:text-white rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500" />
          <span class="text-sm text-gray-400 ml-1">.livespace.io</span>
        </div>
        <p *ngIf="form.get('subdomain')?.invalid && form.get('subdomain')?.touched"
          class="text-xs text-red-500 mt-1">Only letters, numbers, and hyphens allowed</p>
      </div>

      <!-- API Key -->
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">API Key</label>
        <input formControlName="api_key" type="text" placeholder="Your API key"
          class="w-full px-3 py-2 border border-gray-200 dark:border-gray-600 dark:bg-[#252c5f] dark:text-white rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500" />
      </div>

      <!-- API Secret -->
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">API Secret</label>
        <div class="relative">
          <input formControlName="api_secret" [type]="showSecret ? 'text' : 'password'" placeholder="Your API secret"
            class="w-full px-3 py-2 pr-10 border border-gray-200 dark:border-gray-600 dark:bg-[#252c5f] dark:text-white rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500" />
          <button type="button" (click)="toggleSecret()" class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
            <!-- Eye icon -->
            <svg *ngIf="!showSecret" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
            </svg>
            <!-- Eye-off icon -->
            <svg *ngIf="showSecret" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>
            </svg>
          </button>
        </div>
      </div>

      <!-- Error -->
      <div *ngIf="error$ | async as error" class="flex items-center gap-2 p-3 bg-red-50 dark:bg-red-900/20 border border-red-100 dark:border-red-800 rounded-lg">
        <svg class="w-4 h-4 text-red-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
        </svg>
        <p class="text-sm text-red-700 dark:text-red-300">{{ error }}</p>
      </div>

      <!-- Actions -->
      <div class="flex gap-3 pt-2">
        <button type="button" (click)="close()"
          class="flex-1 px-4 py-2.5 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg font-medium text-sm transition-colors">
          Cancel
        </button>
        <button type="submit" [disabled]="(connecting$ | async) || form.invalid"
          class="flex-1 px-4 py-2.5 text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed rounded-lg font-medium text-sm flex items-center justify-center gap-2 transition-colors">
          <!-- Spinner -->
          <svg *ngIf="connecting$ | async" class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <span>{{ (connecting$ | async) ? 'Connecting...' : 'Connect' }}</span>
        </button>
      </div>
    </form>
  </div>
</div>
